import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Card from 'components/Card';
import { solutionCards } from 'sections/DigitalTools/ShipSchedules/data';
import { Card as CardType} from 'sections/DigitalTools/ShipSchedules/types';
import styles from 'sections/DigitalTools/ShipSchedules/components/SectionSolutions/SectionSolutions.module.scss';

const cn = classNames.bind(styles);

const SectionSolutions = (): ReactElement => {
  const cardsElements = solutionCards.map((card: CardType) => {
    return (
      <Card className={cn('card')} key={card.id}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__heading-box')}>
            <h4 className={cn('card__heading')}>
              <span>{card.title.firstLine}</span>{' '}
              <span>{card.title.secondLine}</span>
            </h4>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('solutions')}>
      <div className={cn('container')}>

        <h2 className={cn('solutions__heading')}>
          Solutions
        </h2>

        <div className={cn('solutions__cards')}>
          {cardsElements}
        </div>

      </div>
    </section>
  );
};

export default SectionSolutions;